// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3oorT","type":"styles_type__2TWF-","choices":"styles_choices__6aS20"};